import { render, staticRenderFns } from "./PhotoShowView.vue?vue&type=template&id=4e478732"
import script from "./PhotoShowView.vue?vue&type=script&lang=js"
export * from "./PhotoShowView.vue?vue&type=script&lang=js"
import style0 from "./PhotoShowView.vue?vue&type=style&index=0&id=4e478732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports